<div class="card">
  <div class="child-header mb-3">
    <h3 class="font-semibold text-base">Child Actions</h3>
    <div class="child-actions">
      <div class="resolved-toggle">
        <span class="toggle-text">Show resolved</span>
        <p-toggleSwitch [(ngModel)]="showResolved" (ngModelChange)="onResolvedToggle($event)"></p-toggleSwitch>
      </div>
      <button pButton class="btn-primary btn-small" type="button" (click)="create()">
        <i class="pi pi-plus"></i>
        <span class="ml-1 text-sm">Add Child Action</span>
      </button>
    </div>
  </div>
  @if (filteredChildActions.length === 0) {
    <p class="text-grey-500 text-sm">No child actions yet.</p>
  }
  @for (c of pagedChildActions; track c) {
    <div class="child">
      <div>
        <p class="font-semibold text-sm">{{c.ActionDescription}}</p>
        <div class="meta-row">
          <p class="text-xs text-grey-600">Due {{c.ActionDeadline | date:'mediumDate'}} — {{c.AssignedTo}}</p>
          @if (c.Resolved) {
            <p-tag value="Resolved" severity="success" class="resolved-pill"></p-tag>
          }
        </div>
      </div>
      <button pButton class="btn-inverse btn-compact view-btn" type="button" (click)="open(c.ActionID)">
        <i class="pi pi-eye view-icon"></i>
        <span class="view-label">View</span>
      </button>
    </div>
  }
  @if (filteredChildActions.length >= 5) {
    <div class="paginator-wrapper">
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="filteredChildActions.length"
        [rowsPerPageOptions]="[5,10,20]"
        [pageLinkSize]="3"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  }
</div>
